// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toastification-close-icon[data-v-55dd3057],.toastification-title[data-v-55dd3057]{line-height:26px}.toastification-title[data-v-55dd3057]{color:inherit}", ""]);
// Exports
module.exports = exports;
